const uploadsApiFactory = (axios) => ({
  getUploads: async (id) => {
    return (await axios.get(`/uploads/parents/${id}`)).data;
  },
});

export { uploadsApiFactory };
